import { LegacyChecklistRecord } from '@/ui/pages/inspection/LegacyChecklistRecord';
import { AssetsDocumentStubActionable, processFile } from '@/services/assets-api/AssetsDocumentService';
import { isArray } from 'lodash';
import { ResponsesTypes } from '@/entities/checklist';

type AssetsPhotoStubActionableArray = Array<AssetsDocumentStubActionable | Record<string, unknown>>;

interface FormItem {
  response: Record<string, unknown> | AssetsPhotoStubActionableArray;
  items: Array<FormItem>;
  response_type: string;
}

export const processFiles = async (inspectionRecord: LegacyChecklistRecord): Promise<LegacyChecklistRecord> => {
  await processFilePerItem(inspectionRecord.form as unknown as FormItem);

  return inspectionRecord;
};

const processFilePerItem = async (item: FormItem) => {
  if (canProcessItem(item)) {
    item.response = await processMultipleFileResponse(item.response as Array<AssetsDocumentStubActionable>);
  }

  if (item.items && item.items.length > 0) {
    const promises = item.items.map(processFilePerItem);
    await Promise.all(promises);
  }
};

const processMultipleFileResponse = async (files: Array<AssetsDocumentStubActionable>) => {
  const processedFiles = await Promise.all(files.map(processFile));

  return processedFiles
    .filter(file => file && file.file_id !== null) as Array<AssetsDocumentStubActionable>;
};

const canProcessItem = (item: FormItem) => item.response
  && isArray(item.response)
  && item.response.length > 0
  && item.response_type === ResponsesTypes.file;
